export class RateCard {

    private id: string;
    private countryCode: string;
    private cpaCode: string;
    private cpaName: string;
    private language: string;
    private status: string;
    private createdTimestamp: string;

    constructor(raw: any) {
        if (raw) {
            this.setId(raw.id);
            this.setCountryCode(raw.countryCode);
            this.setCpaCode(raw.cpaCode);
            this.setCpaName(raw.cpaName);
            this.setLanguage(raw.language);
            this.setStatus(raw.status);
            this.setCreatedTimestamp(raw.createdTimestamp);
        }
    }

    public getId(): string {
        return this.id;
    }

    public setId(id: string): void {
        this.id = id;
    }

    public getCountryCode(): string {
        return this.countryCode;
    }

    public setCountryCode(countryCode: string): void {
        this.countryCode = countryCode;
    }

    public getCpaCode(): string {
        return this.cpaCode;
    }

    public setCpaCode(cpaCode: string): void {
        this.cpaCode = cpaCode;
    }

    public getCpaName(): string {
        return this.cpaName;
    }

    public setCpaName(cpaName: string): void {
        this.cpaName = cpaName;
    }

    public getLanguage(): string {
        return this.language;
    }

    public setLanguage(language: string): void {
        this.language = language;
    }

    public getStatus(): string {
        return this.status;
    }

    public setStatus(status: string): void {
        this.status = status;
    }

    public getCreatedTimestamp(): string {
        return this.createdTimestamp;
    }

    public setCreatedTimestamp(createdTimestamp: string): void {
        this.createdTimestamp = createdTimestamp;
    }

}

export namespace RateCard {

    export enum Status {
        NEW = 'NEW',
        INPR = 'INPR',
        READY = 'READY',
        INV = 'INV',
        FAIL = 'FAIL'
    }

}